import fetch from '../../common/services/api/fetch';

export default function removePinnedExtension(urlName) {
    return fetch(
        `/ui/users/preferences/pinned_extensions/delete?url_name=${encodeURIComponent(urlName)}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );
}
